import { Injectable } from '@angular/core';

import { toFixed } from '../../../../core/services/utils/numbers';
import { ClienteAnaliseMercadoLancamentoMes } from '../cliente-analise-mercado-lancamento-mes';

/** Totais da quantidade potencial anual, trimestral e semestral */
export class QuantidadePotencialTotais {
    /** Quantidade Potencial Total Anual */
    quantidadePotencial = 0;
    /** Quantidade Potencial Total do Trimestre 1 */
    quantidadePotencialTrimestre1 = 0;
    /** Quantidade Potencial Total do Trimestre 2 */
    quantidadePotencialTrimestre2 = 0;
    /** Quantidade Potencial Total do Trimestre 3 */
    quantidadePotencialTrimestre3 = 0;
    /** Quantidade Potencial Total do Trimestre 4 */
    quantidadePotencialTrimestre4 = 0;
    /** Quantidade Potencial Total do Semestre 1 */
    quantidadePotencialSemestre1 = 0;
    /** Quantidade Potencial Total do Semestre 2 */
    quantidadePotencialSemestre2 = 0;
}

/** Totais do peso potencial anual, trimestral e semestral */
export class PesoPotencialTotais {
    /** Peso Potencial Total Anual */
    pesoPotencial = 0;
    /** Peso Potencial Total do Trimestre 1 */
    pesoPotencialTrimestre1 = 0;
    /** Peso Potencial Total do Trimestre 2 */
    pesoPotencialTrimestre2 = 0;
    /** Peso Potencial Total do Trimestre 3 */
    pesoPotencialTrimestre3 = 0;
    /** Peso Potencial Total do Trimestre 4 */
    pesoPotencialTrimestre4 = 0;
    /** Peso Potencial Total do Semestre 1 */
    pesoPotencialSemestre1 = 0;
    /** Peso Potencial Total do Semestre 2 */
    pesoPotencialSemestre2 = 0;
}

/** Totais do valor potencial anual, trimestral e semestral */
export class ValorPotencialTotais {
    /** Valor Potencial Total Anual */
    valorPotencial = 0;
    /** Valor Potencial Total do Trimestre 1 */
    valorPotencialTrimestre1 = 0;
    /** Valor Potencial Total do Trimestre 2 */
    valorPotencialTrimestre2 = 0;
    /** Valor Potencial Total do Trimestre 3 */
    valorPotencialTrimestre3 = 0;
    /** Valor Potencial Total do Trimestre 4 */
    valorPotencialTrimestre4 = 0;
    /** Valor Potencial Total do Semestre 1 */
    valorPotencialSemestre1 = 0;
    /** Valor Potencial Total do Semestre 2 */
    valorPotencialSemestre2 = 0;
}

/** Totais da quantidade pretendida anual, trimestral e semestral */
export class QuantidadePretendidaTotais {
    /** Quantidade Pretendida Total Anual */
    quantidadePretendida = 0;
    /** Quantidade Pretendida Total do Trimestre 1 */
    quantidadePretendidaTrimestre1 = 0;
    /** Quantidade Pretendida Total do Trimestre 2 */
    quantidadePretendidaTrimestre2 = 0;
    /** Quantidade Pretendida Total do Trimestre 3 */
    quantidadePretendidaTrimestre3 = 0;
    /** Quantidade Pretendida Total do Trimestre 4 */
    quantidadePretendidaTrimestre4 = 0;
    /** Quantidade Pretendida Total do Semestre 1 */
    quantidadePretendidaSemestre1 = 0;
    /** Quantidade Pretendida Total do Semestre 2 */
    quantidadePretendidaSemestre2 = 0;
}

/** Totais do peso pretendido anual, trimestral e semestral */
export class PesoPretendidoTotais {
    /** Peso Pretendida Total Anual */
    pesoPretendido = 0;
    /** Peso Pretendida Total do Trimestre 1 */
    pesoPretendidoTrimestre1 = 0;
    /** Peso Pretendida Total do Trimestre 2 */
    pesoPretendidoTrimestre2 = 0;
    /** Peso Pretendida Total do Trimestre 3 */
    pesoPretendidoTrimestre3 = 0;
    /** Peso Pretendida Total do Trimestre 4 */
    pesoPretendidoTrimestre4 = 0;
    /** Peso Pretendida Total do Semestre 1 */
    pesoPretendidoSemestre1 = 0;
    /** Peso Pretendida Total do Semestre 2 */
    pesoPretendidoSemestre2 = 0;
}


/** Totais do valor pretendido anual, trimestral e semestral */
export class ValorPretendidoTotais {
    /** Valor Pretendido Total Anual */
    valorPretendido = 0;
    /** Valor Pretendido Total do Trimestre 1 */
    valorPretendidoTrimestre1 = 0;
    /** Valor Pretendido Total do Trimestre 2 */
    valorPretendidoTrimestre2 = 0;
    /** Valor Pretendido Total do Trimestre 3 */
    valorPretendidoTrimestre3 = 0;
    /** Valor Pretendido Total do Trimestre 4 */
    valorPretendidoTrimestre4 = 0;
    /** Valor Pretendido Total do Semestre 1 */
    valorPretendidoSemestre1 = 0;
    /** Valor Pretendido Total do Semestre 2 */
    valorPretendidoSemestre2 = 0;
}

/** Totais da quantidade projetada anual, trimestral e semestral */
export class QuantidadeProjetadaTotais {
    /** Quantidade Projetada Total Anual */
    quantidadeProjetada = 0;
    /** Quantidade Projetada Total do Trimestre 1 */
    quantidadeProjetadaTrimestre1 = 0;
    /** Quantidade Projetada Total do Trimestre 2 */
    quantidadeProjetadaTrimestre2 = 0;
    /** Quantidade Projetada Total do Trimestre 3 */
    quantidadeProjetadaTrimestre3 = 0;
    /** Quantidade Projetada Total do Trimestre 4 */
    quantidadeProjetadaTrimestre4 = 0;
    /** Quantidade Projetada Total do Semestre 1 */
    quantidadeProjetadaSemestre1 = 0;
    /** Quantidade Projetada Total do Semestre 2 */
    quantidadeProjetadaSemestre2 = 0;
}

/** Totais do peso projetado anual, trimestral e semestral */
export class PesoProjetadoTotais {
    /** Peso Projetada Total Anual */
    pesoProjetado = 0;
    /** Peso Projetada Total do Trimestre 1 */
    pesoProjetadoTrimestre1 = 0;
    /** Peso Projetada Total do Trimestre 2 */
    pesoProjetadoTrimestre2 = 0;
    /** Peso Projetada Total do Trimestre 3 */
    pesoProjetadoTrimestre3 = 0;
    /** Peso Projetada Total do Trimestre 4 */
    pesoProjetadoTrimestre4 = 0;
    /** Peso Projetada Total do Semestre 1 */
    pesoProjetadoSemestre1 = 0;
    /** Peso Projetada Total do Semestre 2 */
    pesoProjetadoSemestre2 = 0;
}


/** Totais do valor projetado anual, trimestral e semestral */
export class ValorProjetadoTotais {
    /** Valor Projetado Total Anual */
    valorProjetado = 0;
    /** Valor Projetado Total do Trimestre 1 */
    valorProjetadoTrimestre1 = 0;
    /** Valor Projetado Total do Trimestre 2 */
    valorProjetadoTrimestre2 = 0;
    /** Valor Projetado Total do Trimestre 3 */
    valorProjetadoTrimestre3 = 0;
    /** Valor Projetado Total do Trimestre 4 */
    valorProjetadoTrimestre4 = 0;
    /** Valor Projetado Total do Semestre 1 */
    valorProjetadoSemestre1 = 0;
    /** Valor Projetado Total do Semestre 2 */
    valorProjetadoSemestre2 = 0;
}


@Injectable({
    providedIn: 'root'
})
export class ClienteAnaliseMercadoLancamentoMesCalculoService {

    /** Calcula a quantidade potencial total anual, trimestral e semestral com base nos meses */
    calcularQuantidadePotencialTotais(meses: ClienteAnaliseMercadoLancamentoMes[]): QuantidadePotencialTotais {
        if (!meses) {
            return new QuantidadePotencialTotais();
        }

        // Anual
        let total = 0;
        // Trimestral
        let totalTrimestre1 = 0;
        let totalTrimestre2 = 0;
        let totalTrimestre3 = 0;
        let totalTrimestre4 = 0;
        // Semestral
        let totalSemestre1 = 0;
        let totalSemestre2 = 0;
        meses.forEach(mes => {
            const quantidadePotencial = mes.quantidadePotencial ? Number(mes.quantidadePotencial) : 0;

            // Anual
            total += quantidadePotencial;

            // Trimestral
            switch (mes.trimestre) {
                case 1:
                    totalTrimestre1 += quantidadePotencial;
                    break;
                case 2:
                    totalTrimestre2 += quantidadePotencial;
                    break;
                case 3:
                    totalTrimestre3 += quantidadePotencial;
                    break;
                case 4:
                    totalTrimestre4 += quantidadePotencial;
                    break;
            }

            // Semestral
            switch (mes.semestre) {
                case 1:
                    totalSemestre1 += quantidadePotencial;
                    break;
                case 2:
                    totalSemestre2 += quantidadePotencial;
                    break;
            }
        });

        const totais = new QuantidadePotencialTotais();
        // Anual
        totais.quantidadePotencial = toFixed(total, 4);
        // Trimestral
        totais.quantidadePotencialTrimestre1 = toFixed(totalTrimestre1, 4);
        totais.quantidadePotencialTrimestre2 = toFixed(totalTrimestre2, 4);
        totais.quantidadePotencialTrimestre3 = toFixed(totalTrimestre3, 4);
        totais.quantidadePotencialTrimestre4 = toFixed(totalTrimestre4, 4);
        // Semestral
        totais.quantidadePotencialSemestre1 = toFixed(totalSemestre1, 4);
        totais.quantidadePotencialSemestre2 = toFixed(totalSemestre2, 4);

        return totais;
    }

    /** Calcula o peso potencial total anual, trimestral e semestral com base nos meses */
    calcularPesoPotencialTotais(meses: ClienteAnaliseMercadoLancamentoMes[]): PesoPotencialTotais {
        if (!meses) {
            return new PesoPotencialTotais();
        }

        // Anual
        let total = 0;
        // Trimestral
        let totalTrimestre1 = 0;
        let totalTrimestre2 = 0;
        let totalTrimestre3 = 0;
        let totalTrimestre4 = 0;
        // Semestral
        let totalSemestre1 = 0;
        let totalSemestre2 = 0;
        meses.forEach(mes => {
            const pesoPotencial = mes.pesoPotencial ? Number(mes.pesoPotencial) : 0;

            // Anual
            total += pesoPotencial;

            // Trimestral
            switch (mes.trimestre) {
                case 1:
                    totalTrimestre1 += pesoPotencial;
                    break;
                case 2:
                    totalTrimestre2 += pesoPotencial;
                    break;
                case 3:
                    totalTrimestre3 += pesoPotencial;
                    break;
                case 4:
                    totalTrimestre4 += pesoPotencial;
                    break;
            }

            // Semestral
            switch (mes.semestre) {
                case 1:
                    totalSemestre1 += pesoPotencial;
                    break;
                case 2:
                    totalSemestre2 += pesoPotencial;
                    break;
            }
        });

        const totais = new PesoPotencialTotais();
        // Anual
        totais.pesoPotencial = toFixed(total, 4);
        // Trimestral
        totais.pesoPotencialTrimestre1 = toFixed(totalTrimestre1, 4);
        totais.pesoPotencialTrimestre2 = toFixed(totalTrimestre2, 4);
        totais.pesoPotencialTrimestre3 = toFixed(totalTrimestre3, 4);
        totais.pesoPotencialTrimestre4 = toFixed(totalTrimestre4, 4);
        // Semestral
        totais.pesoPotencialSemestre1 = toFixed(totalSemestre1, 4);
        totais.pesoPotencialSemestre2 = toFixed(totalSemestre2, 4);

        return totais;
    }

    /** Calcula o valor potencial total anual, trimestral e semestral com base nos meses */
    calcularValorPotencialTotais(meses: ClienteAnaliseMercadoLancamentoMes[]): ValorPotencialTotais {
        if (!meses) {
            return new ValorPotencialTotais();
        }

        // Anual
        let total = 0;
        // Trimestral
        let totalTrimestre1 = 0;
        let totalTrimestre2 = 0;
        let totalTrimestre3 = 0;
        let totalTrimestre4 = 0;
        // Semestral
        let totalSemestre1 = 0;
        let totalSemestre2 = 0;
        meses.forEach(mes => {
            const valorPotencial = mes.valorPotencial ? Number(mes.valorPotencial) : 0;

            // Anual
            total += valorPotencial;

            // Trimestral
            switch (mes.trimestre) {
                case 1:
                    totalTrimestre1 += valorPotencial;
                    break;
                case 2:
                    totalTrimestre2 += valorPotencial;
                    break;
                case 3:
                    totalTrimestre3 += valorPotencial;
                    break;
                case 4:
                    totalTrimestre4 += valorPotencial;
                    break;
            }

            // Semestral
            switch (mes.semestre) {
                case 1:
                    totalSemestre1 += valorPotencial;
                    break;
                case 2:
                    totalSemestre2 += valorPotencial;
                    break;
            }
        });

        const totais = new ValorPotencialTotais();
        // Anual
        totais.valorPotencial = toFixed(total, 2);
        // Trimestral
        totais.valorPotencialTrimestre1 = toFixed(totalTrimestre1, 2);
        totais.valorPotencialTrimestre2 = toFixed(totalTrimestre2, 2);
        totais.valorPotencialTrimestre3 = toFixed(totalTrimestre3, 2);
        totais.valorPotencialTrimestre4 = toFixed(totalTrimestre4, 2);
        // Semestral
        totais.valorPotencialSemestre1 = toFixed(totalSemestre1, 2);
        totais.valorPotencialSemestre2 = toFixed(totalSemestre2, 2);

        return totais;
    }

    /** Calcula a quantidade pretendida total anual, trimestral e semestral com base nos meses */
    calcularQuantidadePretendidaTotais(meses: ClienteAnaliseMercadoLancamentoMes[]): QuantidadePretendidaTotais {
        if (!meses) {
            return new QuantidadePretendidaTotais();
        }

        // Anual
        let total = 0;
        // Trimestral
        let totalTrimestre1 = 0;
        let totalTrimestre2 = 0;
        let totalTrimestre3 = 0;
        let totalTrimestre4 = 0;
        // Semestral
        let totalSemestre1 = 0;
        let totalSemestre2 = 0;
        meses.forEach(mes => {
            const quantidadePretendida = mes.quantidadePretendida ? Number(mes.quantidadePretendida) : 0;

            // Anual
            total += quantidadePretendida;

            // Trimestral
            switch (mes.trimestre) {
                case 1:
                    totalTrimestre1 += quantidadePretendida;
                    break;
                case 2:
                    totalTrimestre2 += quantidadePretendida;
                    break;
                case 3:
                    totalTrimestre3 += quantidadePretendida;
                    break;
                case 4:
                    totalTrimestre4 += quantidadePretendida;
                    break;
            }

            // Semestral
            switch (mes.semestre) {
                case 1:
                    totalSemestre1 += quantidadePretendida;
                    break;
                case 2:
                    totalSemestre2 += quantidadePretendida;
                    break;
            }
        });

        const totais = new QuantidadePretendidaTotais();
        // Anual
        totais.quantidadePretendida = toFixed(total, 4);
        // Trimestral
        totais.quantidadePretendidaTrimestre1 = toFixed(totalTrimestre1, 4);
        totais.quantidadePretendidaTrimestre2 = toFixed(totalTrimestre2, 4);
        totais.quantidadePretendidaTrimestre3 = toFixed(totalTrimestre3, 4);
        totais.quantidadePretendidaTrimestre4 = toFixed(totalTrimestre4, 4);
        // Semestral
        totais.quantidadePretendidaSemestre1 = toFixed(totalSemestre1, 4);
        totais.quantidadePretendidaSemestre2 = toFixed(totalSemestre2, 4);

        return totais;
    }

    /** Calcula o peso pretendido total anual, trimestral e semestral com base nos meses */
    calcularPesoPretendidoTotais(meses: ClienteAnaliseMercadoLancamentoMes[]): PesoPretendidoTotais {
        if (!meses) {
            return new PesoPretendidoTotais();
        }

        // Anual
        let total = 0;
        // Trimestral
        let totalTrimestre1 = 0;
        let totalTrimestre2 = 0;
        let totalTrimestre3 = 0;
        let totalTrimestre4 = 0;
        // Semestral
        let totalSemestre1 = 0;
        let totalSemestre2 = 0;
        meses.forEach(mes => {
            const pesoPretendido = mes.pesoPretendido ? Number(mes.pesoPretendido) : 0;

            // Anual
            total += pesoPretendido;

            // Trimestral
            switch (mes.trimestre) {
                case 1:
                    totalTrimestre1 += pesoPretendido;
                    break;
                case 2:
                    totalTrimestre2 += pesoPretendido;
                    break;
                case 3:
                    totalTrimestre3 += pesoPretendido;
                    break;
                case 4:
                    totalTrimestre4 += pesoPretendido;
                    break;
            }

            // Semestral
            switch (mes.semestre) {
                case 1:
                    totalSemestre1 += pesoPretendido;
                    break;
                case 2:
                    totalSemestre2 += pesoPretendido;
                    break;
            }
        });

        const totais = new PesoPretendidoTotais();
        // Anual
        totais.pesoPretendido = toFixed(total, 4);
        // Trimestral
        totais.pesoPretendidoTrimestre1 = toFixed(totalTrimestre1, 4);
        totais.pesoPretendidoTrimestre2 = toFixed(totalTrimestre2, 4);
        totais.pesoPretendidoTrimestre3 = toFixed(totalTrimestre3, 4);
        totais.pesoPretendidoTrimestre4 = toFixed(totalTrimestre4, 4);
        // Semestral
        totais.pesoPretendidoSemestre1 = toFixed(totalSemestre1, 4);
        totais.pesoPretendidoSemestre2 = toFixed(totalSemestre2, 4);

        return totais;
    }

    /** Calcula o valor pretendido total anual, trimestral e semestral com base nos meses */
    calcularValorPretendidoTotais(meses: ClienteAnaliseMercadoLancamentoMes[]): ValorPretendidoTotais {
        if (!meses) {
            return new ValorPretendidoTotais();
        }

        // Anual
        let total = 0;
        // Trimestral
        let totalTrimestre1 = 0;
        let totalTrimestre2 = 0;
        let totalTrimestre3 = 0;
        let totalTrimestre4 = 0;
        // Semestral
        let totalSemestre1 = 0;
        let totalSemestre2 = 0;
        meses.forEach(mes => {
            const valorPretendido = mes.valorPretendido ? Number(mes.valorPretendido) : 0;

            // Anual
            total += valorPretendido;

            // Trimestral
            switch (mes.trimestre) {
                case 1:
                    totalTrimestre1 += valorPretendido;
                    break;
                case 2:
                    totalTrimestre2 += valorPretendido;
                    break;
                case 3:
                    totalTrimestre3 += valorPretendido;
                    break;
                case 4:
                    totalTrimestre4 += valorPretendido;
                    break;
            }

            // Semestral
            switch (mes.semestre) {
                case 1:
                    totalSemestre1 += valorPretendido;
                    break;
                case 2:
                    totalSemestre2 += valorPretendido;
                    break;
            }
        });

        const totais = new ValorPretendidoTotais();
        // Anual
        totais.valorPretendido = toFixed(total, 2);
        // Trimestral
        totais.valorPretendidoTrimestre1 = toFixed(totalTrimestre1, 2);
        totais.valorPretendidoTrimestre2 = toFixed(totalTrimestre2, 2);
        totais.valorPretendidoTrimestre3 = toFixed(totalTrimestre3, 2);
        totais.valorPretendidoTrimestre4 = toFixed(totalTrimestre4, 2);
        // Semestral
        totais.valorPretendidoSemestre1 = toFixed(totalSemestre1, 2);
        totais.valorPretendidoSemestre2 = toFixed(totalSemestre2, 2);

        return totais;
    }

    /** Calcula a quantidade projetada total anual, trimestral e semestral com base nos meses */
    calcularQuantidadeProjetadaTotais(meses: ClienteAnaliseMercadoLancamentoMes[]): QuantidadeProjetadaTotais {
        if (!meses) {
            return new QuantidadeProjetadaTotais();
        }

        // Anual
        let total = 0;
        // Trimestral
        let totalTrimestre1 = 0;
        let totalTrimestre2 = 0;
        let totalTrimestre3 = 0;
        let totalTrimestre4 = 0;
        // Semestral
        let totalSemestre1 = 0;
        let totalSemestre2 = 0;
        meses.forEach(mes => {
            const quantidadeProjetada = mes.quantidadeProjetada ? Number(mes.quantidadeProjetada) : 0;

            // Anual
            total += quantidadeProjetada;

            // Trimestral
            switch (mes.trimestre) {
                case 1:
                    totalTrimestre1 += quantidadeProjetada;
                    break;
                case 2:
                    totalTrimestre2 += quantidadeProjetada;
                    break;
                case 3:
                    totalTrimestre3 += quantidadeProjetada;
                    break;
                case 4:
                    totalTrimestre4 += quantidadeProjetada;
                    break;
            }

            // Semestral
            switch (mes.semestre) {
                case 1:
                    totalSemestre1 += quantidadeProjetada;
                    break;
                case 2:
                    totalSemestre2 += quantidadeProjetada;
                    break;
            }
        });

        const totais = new QuantidadeProjetadaTotais();
        // Anual
        totais.quantidadeProjetada = toFixed(total, 4);
        // Trimestral
        totais.quantidadeProjetadaTrimestre1 = toFixed(totalTrimestre1, 4);
        totais.quantidadeProjetadaTrimestre2 = toFixed(totalTrimestre2, 4);
        totais.quantidadeProjetadaTrimestre3 = toFixed(totalTrimestre3, 4);
        totais.quantidadeProjetadaTrimestre4 = toFixed(totalTrimestre4, 4);
        // Semestral
        totais.quantidadeProjetadaSemestre1 = toFixed(totalSemestre1, 4);
        totais.quantidadeProjetadaSemestre2 = toFixed(totalSemestre2, 4);

        return totais;
    }

    /** Calcula o peso projetado total anual, trimestral e semestral com base nos meses */
    calcularPesoProjetadoTotais(meses: ClienteAnaliseMercadoLancamentoMes[]): PesoProjetadoTotais {
        if (!meses) {
            return new PesoProjetadoTotais();
        }

        // Anual
        let total = 0;
        // Trimestral
        let totalTrimestre1 = 0;
        let totalTrimestre2 = 0;
        let totalTrimestre3 = 0;
        let totalTrimestre4 = 0;
        // Semestral
        let totalSemestre1 = 0;
        let totalSemestre2 = 0;
        meses.forEach(mes => {
            const pesoProjetado = mes.pesoProjetado ? Number(mes.pesoProjetado) : 0;

            // Anual
            total += pesoProjetado;

            // Trimestral
            switch (mes.trimestre) {
                case 1:
                    totalTrimestre1 += pesoProjetado;
                    break;
                case 2:
                    totalTrimestre2 += pesoProjetado;
                    break;
                case 3:
                    totalTrimestre3 += pesoProjetado;
                    break;
                case 4:
                    totalTrimestre4 += pesoProjetado;
                    break;
            }

            // Semestral
            switch (mes.semestre) {
                case 1:
                    totalSemestre1 += pesoProjetado;
                    break;
                case 2:
                    totalSemestre2 += pesoProjetado;
                    break;
            }
        });

        const totais = new PesoProjetadoTotais();
        // Anual
        totais.pesoProjetado = toFixed(total, 4);
        // Trimestral
        totais.pesoProjetadoTrimestre1 = toFixed(totalTrimestre1, 4);
        totais.pesoProjetadoTrimestre2 = toFixed(totalTrimestre2, 4);
        totais.pesoProjetadoTrimestre3 = toFixed(totalTrimestre3, 4);
        totais.pesoProjetadoTrimestre4 = toFixed(totalTrimestre4, 4);
        // Semestral
        totais.pesoProjetadoSemestre1 = toFixed(totalSemestre1, 4);
        totais.pesoProjetadoSemestre2 = toFixed(totalSemestre2, 4);

        return totais;
    }

    /** Calcula o valor projetado total anual, trimestral e semestral com base nos meses */
    calcularValorProjetadoTotais(meses: ClienteAnaliseMercadoLancamentoMes[]): ValorProjetadoTotais {
        if (!meses) {
            return new ValorProjetadoTotais();
        }

        // Anual
        let total = 0;
        // Trimestral
        let totalTrimestre1 = 0;
        let totalTrimestre2 = 0;
        let totalTrimestre3 = 0;
        let totalTrimestre4 = 0;
        // Semestral
        let totalSemestre1 = 0;
        let totalSemestre2 = 0;
        meses.forEach(mes => {
            const valorProjetado = mes.valorProjetado ? Number(mes.valorProjetado) : 0;

            // Anual
            total += valorProjetado;

            // Trimestral
            switch (mes.trimestre) {
                case 1:
                    totalTrimestre1 += valorProjetado;
                    break;
                case 2:
                    totalTrimestre2 += valorProjetado;
                    break;
                case 3:
                    totalTrimestre3 += valorProjetado;
                    break;
                case 4:
                    totalTrimestre4 += valorProjetado;
                    break;
            }

            // Semestral
            switch (mes.semestre) {
                case 1:
                    totalSemestre1 += valorProjetado;
                    break;
                case 2:
                    totalSemestre2 += valorProjetado;
                    break;
            }
        });

        const totais = new ValorProjetadoTotais();
        // Anual
        totais.valorProjetado = toFixed(total, 2);
        // Trimestral
        totais.valorProjetadoTrimestre1 = toFixed(totalTrimestre1, 2);
        totais.valorProjetadoTrimestre2 = toFixed(totalTrimestre2, 2);
        totais.valorProjetadoTrimestre3 = toFixed(totalTrimestre3, 2);
        totais.valorProjetadoTrimestre4 = toFixed(totalTrimestre4, 2);
        // Semestral
        totais.valorProjetadoSemestre1 = toFixed(totalSemestre1, 2);
        totais.valorProjetadoSemestre2 = toFixed(totalSemestre2, 2);

        return totais;
    }
}
